import type { ColumnDef, CellContext } from '@tanstack/vue-table'
import { h } from 'vue'
import { Button } from '~/components/ui/button'
import SortIcon from '~/components/SortIcon.vue'
import DataTableFilterableHeader from '~/components/ui/table/DataTableFilterableHeader.vue'

export const createColumns = (rawDataKeys: string[], assets: FilterOptionItem[]): ColumnDef<EsgMetricRawData>[] => {
  const baseColumns: ColumnDef<EsgMetricRawData>[] = [
    {
      id: 'activity_date',
      accessorKey: 'activity_date',
      header: ({ column }) => {
        const isSorted = column.getIsSorted()
        const sortIconStyling = isSorted === 'asc' ? 'text-green-500' : isSorted === 'desc' ? 'text-red-500 rotate-180' : ''

        return h('div', { class: 'flex justify-between items-center w-full' }, [
          h('span', { class: 'text-sm text-slate-800 font-semibold' }, 'Activity Date'),
          h(Button, {
            class: 'text-main-primary',
            variant: 'ghost',
            onClick: () => column.toggleSorting(isSorted === 'asc', true),
          }, () => h(SortIcon, { customStyle: `size-5 ${sortIconStyling}` })),
        ])
      },
      cell: ({ row }) => {
        const date = new Date(row.original.activity_date)
        return h('span', { class: 'text-sm text-theme-text-black' }, date.toLocaleDateString('en-GB'))
      },
    },
    {
      id: 'asset',
      header: ({ column }) => h(DataTableFilterableHeader, {
        column,
        title: 'Asset',
        filterData: assets,
      }),
      accessorKey: 'asset.name',
      cell: ({ row }) => h('span', { class: 'text-sm text-theme-text-black' }, row.original.asset.name),
    },
  ]

  const dynamicColumns: ColumnDef<EsgMetricRawData>[] = rawDataKeys.map(key => ({
    id: `raw_data.${key}`,
    header: () => {
      return h('div', { class: 'flex justify-between items-center w-full' }, [
        h('span', { class: 'text-sm text-slate-800 font-semibold' }, key),
      ])
    },
    accessorFn: (row: EsgMetricRawData) => row.raw_data[key] || '-',
    cell: (context: CellContext<EsgMetricRawData, unknown>) => {
      const value = context.getValue() as string
      return h('span', { class: 'text-sm text-theme-text-black' }, value)
    },
  }))

  return [...baseColumns, ...dynamicColumns]
}
